import { createSlice } from '@reduxjs/toolkit'
import InvalidElement from '../../domain/Folder/InvalidElementInterface'

interface InvalidElementState {
  invalidElements: InvalidElement[],
  count: number,
  provided: number
}

const initialState: InvalidElementState = {
  invalidElements: [],
  count: 0,
  provided: 0
}

export const receiptCounterSlice = createSlice({
  name: 'receiptCounter',
  initialState,
  reducers: {
    incrementCounter: (state) => {
      state.count += 1
    },
    decrementCounter: (state) => {
      if (state.count > 0) {
        state.count -= 1
      }
    },
    incrementProvided: (state) => {
      state.provided += 1
    },
    decrementProvided: (state) => {
      if (state.provided > 0) {
        state.provided -= 1
      }
    },
    resetCounter: (state) => {
      state.count = 0;
      state.provided = 0;
    },
  }
})

export const {
    incrementCounter,
    decrementCounter,
    incrementProvided,
    decrementProvided,
    resetCounter,
} = receiptCounterSlice.actions
export default receiptCounterSlice.reducer
